import { purify } from "../_src/components/purify";

export function searchNoticias() {
    var btnLoadMore = document.querySelector("[data-action=load-more]")

    function search(loadMore) {
        const currentPortal = document.querySelector(".ifag__events-and-business") ? "ifag" : "portal";

        var form = document.querySelector('#filter-events');
        var data = new FormData(form);
        var filterValue = "";

        if (btnLoadMore.classList.contains("hidden")) {
            btnLoadMore.classList.remove("hidden")
        }

        if (!loadMore) {
            document.querySelector(".loader-events").classList.remove("hidden")
            document.querySelector("#result-events").innerHTML = ""
        }

        if (document.querySelector("#filter-events [data-action=filter-content].active")) {
            filterValue = document.querySelector("#filter-events [data-action=filter-content].active").dataset.filter
        }

        document.querySelector("#term").parentNode.classList.add("loading")
        btnLoadMore.classList.add("loading")

        document.querySelectorAll("#filter-events fieldset").forEach(function (el) {
            el.classList.add("disabled")
        })

        const params = new URLSearchParams({
            loadmore: loadMore,
            filter: filterValue,
            portal: currentPortal
        });

        fetch(`/eventos/ajax/events.html/p${btnLoadMore.getAttribute("data-page")}?${params.toString()}`, {
            method: "POST",
            body: data
        }).then((response) => {
            return response.text();
        }).then((response) => {
            if (loadMore) {
                document.querySelector("#result-events").insertAdjacentHTML('beforeend', response);

                if (document.querySelector("#result-not-found")) {
                    btnLoadMore.classList.add("hidden")
                    document.querySelector("#result-not-found").remove()
                } else {
                    btnLoadMore.classList.remove("hidden")
                }
            } else {
                document.querySelector("#result-events").innerHTML = purify(response);
            }
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            if (!loadMore) {
                btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1
                document.querySelector(".loader-events").classList.add("hidden")
            }

            btnLoadMore.classList.remove("loading")

            document.querySelector("#term").parentNode.classList.remove("loading")

            document.querySelectorAll("#filter-events fieldset").forEach(function (el) {
                el.classList.remove("disabled")
            })

            if(document.querySelector(".event-container")) {
                if(parseInt(document.querySelector(".event-container").dataset.total) < parseInt(btnLoadMore.dataset.page)){
                    btnLoadMore.classList.add("hidden")
                }
            } else {
                btnLoadMore.classList.add("hidden")
            }

        });
    }

    const clearBtn = document.querySelector("[data-action=clear-search]");
    const termInput = document.querySelector("#term");

    function updateClearButtonState() {
        if (!clearBtn) return;
        const hasActiveFilter = document.querySelector("[data-action=filter-content].active");
        const hasText = termInput.value.trim().length > 0;
        const hasSelectFilter = Array.from(document.querySelectorAll('#filter-events select[name="instituicao"], #filter-events select[name="categoria"]'))
            .some((select) => select.value);

        clearBtn.disabled = !(hasActiveFilter || hasText || hasSelectFilter);
    }

    document.querySelectorAll("[data-action=filter-content]").forEach(function (btn) {
        btn.addEventListener("click", function () {

            if (this.classList.contains("active")) {
                btn.classList.remove("active")
            } else {
                btnLoadMore.disabled = false;

                document.querySelectorAll("[data-action=filter-content]").forEach(function (btn) {
                    btn.classList.remove("active")
                })

                this.classList.add("active")
            }

            btnLoadMore.dataset.page = 1
            search(false)
            updateClearButtonState();
        })
    })

    document.querySelectorAll('#filter-events select[name="instituicao"], #filter-events select[name="categoria"]').forEach(function (select) {
        select.addEventListener("change", function () {
            btnLoadMore.dataset.page = "1";
            search(false);
            updateClearButtonState();
        });
    });

    btnLoadMore.addEventListener("click", function () { search(true), btnLoadMore.dataset.page = parseInt(btnLoadMore.dataset.page) + 1 }, false);

    document.querySelector("#filter-events").addEventListener("submit", function (event) { 
        event.preventDefault(), btnLoadMore.dataset.page = "1", search(false) 
        updateClearButtonState();
    }, false);

    if (clearBtn) {
        clearBtn.disabled = true;
        clearBtn.addEventListener("click", function () {
            termInput.value = "";
            document.querySelectorAll("[data-action=filter-content].active").forEach(btn => btn.classList.remove("active"));
            btnLoadMore.dataset.page = "1";
            search(false);
            updateClearButtonState();
        });
    }

    return search(false);
}

if (document.querySelector("#filter-events")) {
    searchNoticias();
}
